import React from "react";
import Header from "../components/Header/Header";
import WelcomeMessage from "../components/WelcomeMessage/WelcomeMessage";
import Contact from "../components/Contact/Contact";
import Services from "../components/Services/Services";
import Subjects from "../components/Subjects/Subjects";
import Pricing from "../components/Pricing/Pricing";
import Team from "../components/Team/Team";

const Home = () => {
  return (
    <div>
      <WelcomeMessage />
      <Services />
      <Subjects />
      <Pricing />
      <Team />
      <Contact />
    </div>
  );
};

export default Home;
